import logo from "../assets/tcl/tcl-logo.svg";

export const TCL_brandVariables = {
  siteTitle: "TCL",
  siteIcon: logo,
  name: "TCL",
  name_small: "TCL",
  logos: {
    large: logo,
    white: logo,
    small: logo,
    medium: logo,
    alt_text: "TCL logo",
    profile: logo,
  },
  brandTheme: "tcl", // Theme of the brand
  site: "", // Live url of site
  authMethod: "email", // Only needed for events, gives user set options to manualy sign up, options are:  email | phone | emailNoVerify
  defaultCountryCode: "SE", // Only needed for retail platforms | For initial phone number | Changes all auth methods`
  defaultLanguage: "",
  brandStoreExtension: "", // Only needed for retail platforms | Extension used for email
  brandValue: "TCL", // Only needed for retail platforms | Brand value needed for BE related functions
  brandIntials: "", // gets added after the username, to drasticaly descrease chance of duplicate usernames across different apps | Only needed for event platforms
  defaultNavigateUrl: "/",
  eventHasAutoQrSignup: false,
  hasSubClients: false,
  subClientsForOverviews: null, // string[] of clients used to fetch multiple types of clients for overview pages
  autoJoinChallenge: false,
  hasFeature: {
    notifications: true,
    themes: false,
    connections: false,
    achievements: false,
    messages: false,
    teams: true,
    news: false,
    challenges: true,
    singleChallenge: true,
    gathers: false,
    preferences: false,
    friends: false,
    zones: false,
    feed: true,
    winners: false,
    schedule: false,
    qrSignUp: false,
    manualSubmissions: true,
    landing: true,
    login: true,
    haslanguagePicker: true,
    getstarted: false,
    hero: true,
    search: false,
    routes: false,
    dailytasks: false,
    games: false,
    treasure_hunt: false,
    activities: false,
  },
  hasAuth: {
    steam: false,
    bnet: false,
    quickSignUp: true,
    google: true,
  },
  layout: {
    challenge: "default",
  },
  event: {
    forcedCredentialPopup: "email",
    eventCode: "", // Only needed for event platforms
    collectionForSubmissions: "",
    documentForSubmissions: "",
    isEvent: true,
    spacecoins_redirect: true,
  },
};
